export const BLOOD_CATEGORY = "Blood";
export const DNA_CATEGORY = "DNA";
export const FOOD_INTOLERANCE_CATEGORY = "Food Intolerance";

export const CATEGORIES = {
  1: BLOOD_CATEGORY,
  2: DNA_CATEGORY,
  3: FOOD_INTOLERANCE_CATEGORY
}

export const STATUS_IDS = {
  new: 1,
  inProgress: 2,
  error: 3,
  verified: 4,
  cancelled: 5,
  processedByInitialLab: 6
};